import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DownloadIcon } from "@heroicons/react/outline";

export interface ExportButtonProps {
  onExport: () => Promise<void>;
  disabled?: boolean;
  className?: string;
}

const ExportButton = ({ onExport, disabled = false, className = "" }: ExportButtonProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (disabled || isLoading) return;

    setIsLoading(true);
    try {
      await onExport();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled || isLoading}
      className={`flex items-center gap-2 px-4 py-2.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {isLoading ? (
        <>
          <svg
            className="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span>{t("statsNew.export.loading")}</span>
        </>
      ) : (
        <>
          <DownloadIcon className="h-5 w-5" />
          <span>{t("statsNew.export.button")}</span>
        </>
      )}
    </button>
  );
};

export default ExportButton;
